import { useEffect } from "react";

import { setPageTitle } from "@/lib/document-title-store";

/**
 * Publica o nome desta página para o título da aba.
 *
 * A página **declara**; quem escreve em `document.title` é o `DocumentTitle`
 * montado uma vez no `App.tsx`. Antes, a página montava um segundo
 * `DocumentTitle` e os dois disputavam a mesma variável.
 *
 * Chame com o valor que pode faltar (`project?.name`) e **antes de qualquer
 * early return** — é uma regra dos hooks, e é também o que conserta o defeito:
 * quando o nome fica `undefined`, o título volta sozinho para o rótulo da rota,
 * em vez de congelar no nome anterior.
 *
 * O cleanup limpa no unmount, então sair da página nunca deixa o nome para trás.
 */
export function useDocumentTitle(name: string | undefined | null): void {
  useEffect(() => {
    setPageTitle(name ?? undefined);
    return () => setPageTitle(undefined);
  }, [name]);
}
